import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SeoArticlePage from "../pages/seo-article/page";
import ListasHoobuyPage from "../pages/articles/listas-hoobuy/page";
import ComparacaoHoobuyPage from "../pages/articles/comparacao/page";
import SegurancaComprasPage from "../pages/articles/seguranca/page";
import EconomizarHoobuyPage from "../pages/articles/economizar/page";
import ProdutosBaratosPage from "../pages/articles/produtos-baratos/page";
import FornecedoresPage from "../pages/articles/fornecedores/page";
import GuiaIniciantesPage from "../pages/articles/guia-iniciantes/page";
import ErrosComunsPage from "../pages/articles/erros-comuns/page";
import MelhoresCategoriasPage from "../pages/articles/melhores-categorias/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guia-hoobuy-spreadsheet-2026",
    element: <SeoArticlePage />,
  },
  {
    path: "/listas-hoobuy-atualizadas-2026",
    element: <ListasHoobuyPage />,
  },
  {
    path: "/comparacao-hoobuy-pandabuy",
    element: <ComparacaoHoobuyPage />,
  },
  {
    path: "/seguranca-compras-hoobuy",
    element: <SegurancaComprasPage />,
  },
  {
    path: "/como-economizar-hoobuy",
    element: <EconomizarHoobuyPage />,
  },
  {
    path: "/produtos-baratos-china-2026",
    element: <ProdutosBaratosPage />,
  },
  {
    path: "/fornecedores-confiaveis-hoobuy",
    element: <FornecedoresPage />,
  },
  {
    path: "/guia-iniciantes-hoobuy",
    element: <GuiaIniciantesPage />,
  },
  {
    path: "/erros-comuns-compras-china",
    element: <ErrosComunsPage />,
  },
  {
    path: "/melhores-categorias-hoobuy-2026",
    element: <MelhoresCategoriasPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;